export function ehAdmin(state) {
  if(state.userInfo == null) return false;
  if(!state.userInfo.usuarioPerfis)
    return false;
  return state.userInfo.usuarioPerfis.find(el => {
      return el.perfil.nome === 'admin';
  }) !== undefined;
}

export function retornaPermissao(state) {
  return function(modulo){
    if(ehAdmin(state)) return { c: true, r: true, u: true, d: true };
    if(!state.permissao.find(el => el.campo == modulo)) return { c: false, r: false, u: false, d: false };
    
    return state.permissao.find(el => el.campo == modulo);
  }
}

export function retornarEmpresas(state) {
  if(ehAdmin)
    return state.listaEmpresas;

  return (state.userInfo?.pessoa?.empresas || []).map((el) => {
    return { value: el.id, text: el.nomeFantasia, data: el };
  });

}